export default __webpack_public_path__ + "static/media/icon_travelport-certified.6d8dd22c.png";